import React from 'react'
import { css } from '@emotion/core'
import { LabelTooltip } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ThingFlag } from '@fs/zion-icon'
import { extractTextFromComponent } from '../../../util/ElementUtil'

const redColor = css`
  color: #bd0057;
`

export default function AccessControl({ accessControl }) {
  const { t } = useTranslation()
  const accessControlText = (
    <div>
      {accessControl.hidden && <div>{t('hidden', 'Hidden')}</div>}
      {accessControl.hideCompletedOrdinances && (
        <div>{t('accessControl.completedOrdsHidden', 'Completed Ordinances Hidden')}</div>
      )}
      {accessControl.locked && <div>{t('accessControl.locked', 'Locked')}</div>}
      {accessControl.ordinanceApprovalRequired && (
        <div>{t('accessControl.ordApprovalRequired', 'Ordinance Approval Required')}</div>
      )}
      {accessControl.ownerRestricted && <div>{t('accessControl.restricted', 'Restricted')}</div>}
      {accessControl.unpublished && <div>{t('accessControl.UNPUBLISHED', 'Unpublished')}</div>}
      {accessControl.russianData && <div>{t('accessControl.russianData', 'Russian Data')}</div>}
    </div>
  )

  if (!accessControl) {
    return null
  }
  return (
    <span aria-label={extractTextFromComponent(accessControlText)}>
      <LabelTooltip
        target={
          <span css={redColor}>
            {t('accessControl.label', 'Access Control')}
            <ThingFlag size="xs" />
          </span>
        }
        label={accessControlText}
      />
    </span>
  )
}
